"use client";

import type {
    ComponentPropsWithoutRef,
    SubmitEvent,
} from "react";
import { siteBuilderSearchTarget } from "./siteBuilderBlockPresentation";
import type { SiteBuilderSearchSuggestion } from "./siteBuilderBlockPresentation";

type SiteBuilderSearchFormProps = ComponentPropsWithoutRef<"form"> & {
    editorMode: boolean;
    readOnly?: boolean;
    suggestions: SiteBuilderSearchSuggestion[];
};

/** Navigates a Web search to its best matching page instead of reloading it. */
export function SiteBuilderSearchForm({
    editorMode,
    onSubmit,
    readOnly,
    suggestions,
    ...formProps
}: SiteBuilderSearchFormProps) {
    const handleSubmit = (event: SubmitEvent<HTMLFormElement>): void => {
        if (editorMode || readOnly) {
            event.preventDefault();
            onSubmit?.(event);

            return;
        }

        const query = new FormData(event.currentTarget).get("q");
        const href = siteBuilderSearchTarget(
            suggestions,
            typeof query === "string" ? query : "",
        );

        event.preventDefault();

        if (href !== null) {
            window.location.assign(href);
        }

        onSubmit?.(event);
    };

    return <form {...formProps} onSubmit={handleSubmit} />;
}
